export const get_roll = (track, division) => {
	let roll = [];
	let new_roll = [] * 128;
	for (var event of track) {
		for (var t = 0; t < t.delta; t++) {
			roll.push(new_roll);
		}

		if (event.noteOn) {
			new_roll[event.noteOn.noteNumber] = event.noteOn.velocity;
		}
		if (event.noteOff) {
			new_roll[event.noteOff.noteNumber] = 0;
		}
	}
	return roll;
};

export const trackToScore = (track, division) => {
	let events = [];
	let activeEvents = new Array(128);
	let t = 0;
	let millisecondsPerQuarter = 60000 / 120;
	let millisecondsPerTick = millisecondsPerQuarter / division;

	for (var event of track) {
		t += event.delta * millisecondsPerTick;

		if (event.setTempo) {
			millisecondsPerQuarter = event.setTempo.millisecondsPerQuarter / 1000;
			millisecondsPerTick = millisecondsPerQuarter / division;
		}
		if (event.noteOn) {
			activeEvents[event.noteOn.noteNumber] = { velocity: event.noteOn.velocity, startMillis: t };
		}
		if (event.noteOff) {
			let ev = { ...activeEvents[event.noteOff.noteNumber], endMillis: t, pitch: event.noteOff.noteNumber };
			events.push(ev);
			activeEvents[event.noteOff.noteNumber] = null;
		}
	}

	let lastMillis = events.sort((a, b) => a.endMillis - b.endMillis)[events.length - 1].endMillis;

	let minPitch = events.sort((a, b) => a.pitch - b.pitch)[0].pitch;

	let maxPitch = events.sort((a, b) => a.pitch - b.pitch)[events.length - 1].pitch;


	return {
		notes: events.sort((a, b) => a.startMillis - b.startMillis),
		nMillis: lastMillis,
		minPitch: minPitch,
		maxPitch: maxPitch,
	};
};

export const hslToHex = (h, s, l) => {
	h /= 360;
	s /= 100;
	l /= 100;
	let r, g, b;
	if (s === 0) {
		r = g = b = l; // achromatic
	} else {
		const hue2rgb = (p, q, t) => {
			if (t < 0) t += 1;
			if (t > 1) t -= 1;
			if (t < 1 / 6) return p + (q - p) * 6 * t;
			if (t < 1 / 2) return q;
			if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
			return p;
		};
		const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
		const p = 2 * l - q;
		r = hue2rgb(p, q, h + 1 / 3);
		g = hue2rgb(p, q, h);
		b = hue2rgb(p, q, h - 1 / 3);
	}
	const toHex = (x) => {
		const hex = Math.round(x * 255).toString(16);
		return hex.length === 1 ? '0' + hex : hex;
	};
	return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
